.chartContainer {
  position: relative;
  width: 100%;
}
